var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main",style:(_vm.playerStyles)},[_c('div',{class:['main-wrap', {hide: _vm.showSubscribe && _vm.size !== 'size-mini'}, {dark: _vm.isDark}, ( _obj = {}, _obj[_vm.size] = _vm.size, _obj )]},[_c('Audio'),_vm._v(" "),_c('Logo'),_vm._v(" "),_c('PlayerMainArtworkMeta'),_vm._v(" "),_c('PlayerMainControls')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }